import type { ReactNode } from 'react'
import { useNavigate } from 'react-router'

import { Icon } from '../../components/Icon'
import { PAGE_GUTTER_DESKTOP } from '../../components/PageShell'

export function TransportHeader({
  onBack,
}: {
  onBack?: () => void
}): ReactNode {
  const navigate = useNavigate()
  // On a direct arrival (new tab, outside link) there is nothing to go back
  // to inside the app, so Back goes home instead of leaving Medcor.
  const back = () => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0
    if (idx > 0) void navigate(-1)
    else void navigate('/')
  }
  return (
    <header
      className={`flex items-center gap-1.5 border-b border-line-1 px-3 py-2 ${PAGE_GUTTER_DESKTOP}`}
    >
      <button
        type="button"
        aria-label="Back"
        onClick={onBack ?? back}
        className="rounded p-1.5 text-ink-2 hover:bg-bg-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
      >
        <Icon name="chevl" size={18} />
      </button>
      <span className="text-[13px] font-medium text-ink-1">
        Medcor · Transport
      </span>
    </header>
  )
}
